<template>
  <div class="container mx-auto p-8 bg-white rounded-lg rounded-l-none shadow-lg pb-0 md:pb-8 min-div-width">
    <div class="flex">
      <!-- search input field -->
      <div class="w-full">
        <label class="label">
          Search Applications
        </label>
        <input @click="changeSearchCriteria('name.props.name', true)" class="outline-none border rounded border-grey py-2 px-2" type="text" placeholder="type here..." v-model="searchValue">
      </div>
      <!-- search input field -->

      <!-- Refresh button -->
      <button @click="refetchApplications" class="bg-green hover:opacity-75 text-white px-4 h-8 rounded text-lg mr-8" type="button">
        Refresh
      </button>
      <!-- Refresh button -->

      <!-- dropdown -->
      <div class="ml-2 relative">
        <div v-click-outside="() => menuOpened && toggleMenu()" @click="toggleMenu" class="flex items-center justify-center cursor-pointer">
          <span class="text-grey-dark mr-2">Filter</span>
          <svg class="cursor-pointer" width="11px" height="6px" viewBox="0 0 11 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.5">
              <path d="M5.5,6 C5.23993351,6 4.97986701,5.90832554 4.78176949,5.72591207 L0,1.32273152 L1.43646103,0 L5.5,3.74181478 L9.56353897,0 L11,1.32273152 L6.21823051,5.72591207 C6.02013299,5.90832554 5.76006649,6 5.5,6 Z" id="Shape" fill="#2B4864" fill-rule="nonzero"></path>
            </g>
          </svg>
        </div>
        <div v-show="menuOpened" class="z-10 rounded bg-white shadow-md mt-8 absolute mt-12 pin-t pin-r w-48">
          <ul class="list-reset">
            <li>
              <a
                class="cursor-pointer px-4 py-2 block text-navy hover:bg-navy hover:text-white no-underline"
                v-for="state in applicationStates"
                :key="state.label"
                @click="appStateFilter(state.key)"
              >
                {{state.label}} Applications
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- dropdown -->
    </div>
    <vue-table
      :row-data="showApplicationsList"
      :column-heads="columnHeads"
      @rowClick="rowCallback"
      @actionCell="actionCellCTA"
      class="flex flex-col items-center justify-center table-width"
      :is-broker="true"
      :search-criteria="searchCriteria"
      :search-value="searchValue"
      :tool-tip-content="toolTipContent"
      type="brokerAppList"
      @sortBy="sortTableBy"
    />
    <modal name="confirm-cancel" :width="450" :height="150">
      <div class="p-8">
        <div class="text-navy font-semibold">Are you sure you want to cancel this application?</div>
        <div class="flex justify-between mt-8">
          <button class="p-4 rounded-lg hover:bg-grey-lighter" @click="hideCancelModal()">No thanks</button>
          <button class="rounded-lg border border-grey-light p-4 delete hover:opacity-75 text-white" @click="hideAndCancelModal()">Yes, cancel</button>
        </div>
      </div>
    </modal>
    <modal name="ownershipChange" :width="350" :height="150">
      <div class="p-8">
        <h3 class="text-navy font-semibold">The Ownership has now been changed</h3>
        <div class="mt-4 text-center">
          <button class="bg-green hover:opacity-75 text-white py-4 px-8 rounded text-lg" @click="$modal.hide('ownershipChange');">Close</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import StepProgress from '@/components/TableComponents/CompletedSteps.vue';
import Table from '@/components/Table.vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { quotePdf } from '@/utils/pdfMethods';
import moment from 'moment';
import find from 'lodash/find';
import ClickOutside from 'vue-click-outside';

const columnHeads = ['customer name', 'stage', 'loan amount', 'date updated', 'ownership', 'actions']

export default {
  name: 'AggregatorBrokerAppList',
  metaInfo: {
    title: 'Manage My Applications | SocietyOne Personal Loans',
  },
  components: {
    'step-progress': StepProgress,
    'vue-table': Table,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      columnHeads,
      cancelApplicationId: '',
      searchValue: '',
      menuOpened: false,
      searchCriteria: '',
      applicationStates: [ { label: 'All', key: '' }, { label: 'Active', key: ['IN PROGRESS'] }, { label: 'Submitted', key: 'SUBMITTED' }, { label: 'Accepted', key: 'ACCEPTED' }, { label: 'Approved', key: 'APPROVED' }, { label: 'Declined', key: 'DECLINED' }, { label: 'Low Score', key: 'LOW SCORE' }, { label: 'No Score', key: 'NO SCORE' } ],
      toolTipContent: {
        content:
          `
          <ul>
            <li>Stage 1 - Quick quote form.</li>
            <li>Stage 2 - Quote summary.</li>
            <li>Stage 3 - Financial information.</li>
            <li>Stage 4 - Conditional offer & document upload.</li>
            <li>Accepted means that the customer has accepted their conditional loan offer.</li>
            <li>No score means that we were unable to find a credit file for your applicant.</li>
            <li>Low score means that the applicant falls outside of our lending criteria.</li>
          </ul>
        `,
        trigger: 'click',
      },
      sortCriteria: [],
      brokerUrl: process.env.BROKER_WEB_PORTAL_URL,
    }
  },
  props: ['brokerId'],
  mounted() {
    const isActiveBroker = find(this.getBrokerTabs, (broker) => broker.id === this.$route.params.id);

    if (!isActiveBroker) {
      this.$router.push('/aggregator/brokers')
    }
  },
  computed: {
    ...mapGetters({
      getBrokerTabs: 'brokers/getBrokerTabs',
      getApplicationList: 'brokers/getApplicationList',
    }),
    showApplicationsList() {
      const appList = this.getApplicationList(this.$route.params.id);
      this.sortCriteria.forEach((item) => {
        appList.sort((a, b) => {
          if (item.type === 'stage') {
            return item.asec
              ? a.actions.props.stage - b.actions.props.stage
              : b.actions.props.stage - a.actions.props.stage
          }
          if (item.type === 'date updated') {
            return item.asec
              ? moment(a.dateUpdated) - moment(b.dateUpdated)
              : moment(b.dateUpdated) - moment(a.dateUpdated)
          }
          if (item.type === 'customer name') {
            const data = item.asec
              ? a.name.props.name > b.name.props.name
              : b.name.props.name > a.name.props.name
            return data ? 1 : -1
          }
          if (item.type === 'loan amount') {
            const parseNumber = (str) => Number(str.replace(/[^0-9.-]+/g, ''));
            return item.asec
              ? parseNumber(a.loanAmount) - parseNumber(b.loanAmount)
              : parseNumber(b.loanAmount) - parseNumber(a.loanAmount)
          }
        })
      })
      return appList
    },
    // baseUrl: process.env.BASE_URL,
    // brokerUrl: process.env.BROKER_WEB_PORTAL_URL,
  },
  methods: {
    ...mapActions({
      cancelApplication: 'application/cancelApplication',
      restartApplication: 'application/restartApplication',
      getApplication: 'application/getApplication',
      fetchBrokersApplications: 'brokers/fetchBrokersApplications',
      changeOwnership: 'brokers/changeOwnership',
    }),
    ...mapMutations({
      toggleBroker: 'brokers/toggleBroker',
    }),
    sortTableBy(criteria) {
      this.sortCriteria = criteria
    },
    async refetchApplications() {
      await this.fetchBrokersApplications({ id: this.$route.params.id, refetch: true })
    },
    showCancelModal(applicationId) {
      this.cancelApplicationId = applicationId;
      this.$modal.show('confirm-cancel');
    },
    hideCancelModal() {
      this.cancelApplicationId = '';
      this.$modal.hide('confirm-cancel');
    },
    async hideAndCancelModal() {
      const response = await this.cancelApplication(this.cancelApplicationId);
      if (response) {
        this.refetchApplications();
      }
      this.cancelApplicationId = '';
      this.$modal.hide('confirm-cancel');
    },
    rowCallback(rowData) {
      this.toggleBroker({ name: rowData.name.props.name, id: rowData.metaData.id })
    },
    appStateFilter(state) {
      this.searchValue = state
    },
    changeSearchCriteria(searchCriteria, clearSearchValue) {
      if (clearSearchValue) {
        this.searchValue = '';
      }
      this.searchCriteria = searchCriteria
    },
    toggleMenu() {
      this.menuOpened = !this.menuOpened;
      this.changeSearchCriteria('stage.props.status')
    },
    async actionCellCTA(data) {
      switch (data.action) {
        case 'cancel':
          this.showCancelModal(data.id)
          break;
        case 'view':
          this.openWindow(data);
          break;
        case 'download':
          const { body } = await this.getApplication(data.id)
          quotePdf(body.application)
          break;
        case 'continue':
          this.openWindow(data);
          break;
        case 'tryAgain':
          const appID = await this.restartApplication(data.id);
          if (appID) {
            data.id = appID
            this.openWindow(data);
          }
          break;
        case 'changeOwnership':
          const confirm = await this.changeOwnership(data)
          if (confirm) {
            this.$modal.show('ownershipChange')
          }
          break;
      }
    },
    openWindow(data) {
      const token = this.$auth.getToken();
      window.open(`${this.brokerUrl}/?applicationId=${data.id}&aggregatorToken=${token}`, '_blank');
    },
  },
};
</script>

<style scoped>
.min-div-width {
  min-width: 1132px;
}
td {
  min-width: 120px;
  max-width: 290px;
}
.table-width {
  min-width: 800px !important;
}
.delete {
  background: #ff1919;
}
</style>



// WEBPACK FOOTER //
// src/pages/Aggregator/AggregatorBrokerAppList.vue